import styled from 'styled-components';
import { Link } from '../../../../../common/modalFooter/ModalFooter.styles';

export const DivFlexWithWrap = styled('div')`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    column-gap: 16px;
    row-gap: 8px;
    width: 330px;
    height: 66px;
`;

export const DivImpactArea = styled('div')`
    display: flex;
    width: 96px;
    align-items: center;
    gap: 4px;
`;

export const DivImpactAreaImage = styled('div')`
    display: block;
    margin: auto 0;
`;

export const DivImpactAreaName = styled('div')`
    display: block;
    width: 70px;
    font-family: 'Proxima Nova' !important;
    font-weight: 400 !important;
    font-size: 10px !important;
    line-height: 12px !important;
    margin: auto 0;
`;

export const DtGroup = styled('div')`
   width: 334px;
   gap: 8px;
   padding: 0 0 16px 0;
`;

export const DtOtherGroup = styled('div')`
   width: 334px;
   gap: 8px;
   padding: 0 0 16px 0;
`;

export const DtBlock = styled('div')`
`;

export const DtRow = styled('div')`
    display: inline-flex;
    width: 100%;
    margin-top: 6px;
`;

export const DtName = styled('div')`
    min-width: 210px;
    width: 211px;
    padding-top: 0;
    margin-right: 16px;
    a {
        font-family: Proxima Nova;
        font-size: 10px;
        font-weight: 400;
        line-height: 12px;
        text-align: left;
        text-decoration: none;
    }
    a:link {
      text-decoration: none;
    }
    a:visited {
      text-decoration: none;
    }
    a:hover {
      text-decoration: none;
    }
    a:active {
      text-decoration: none;
    }
`;

export const DtCmfContainer = styled('div')`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: start;
`;

export const DtCmfImage = styled('div')`
`;

export const DtLink = styled(Link)`
    font-family: Proxima Nova;
    color: #00237B;
    font-weight: 400;
    margin-bottom: 0px;
    text-decoration: none !important;
`;

export const IaLegend = styled('div')`
    width: 330px;
    border: 1px 0px 0px 0px;
    opacity: 0px;
    border-top: 1px solid #D3D3D3;
    margin-top: 4px;

    p, .cmf-impact-area-label {
        padding-top: 16px;
        padding-bottom: 2px;
    }
    &.legend-lpc {
        margin-top: 16px;
        width: 300px;
    }
`;
